import {NavAvatar} from "../../nav/NavAvatar";
import * as React from "react";
import './CommentReply.pcss';
import {Ago} from "./Ago";
import * as moment from "moment-timezone";
import {BellIcon} from "components/widgets/icons/BellIcon";
import {INotification, NotificationTypeHelper} from "data/entities/INotification";
import {ReplyIcon} from "components/widgets/icons/ReplyIcon";
import {MentionIcon} from "components/widgets/icons/MentionIcon";
import {stripHtml} from "utils";

interface Props {
  reply:any;
  relatedNotification:INotification|null;
  hideNotificationIcon:boolean;
}



export const CommentReply = (props:Props) => {

  let nameOrNickname = ''; props.reply.userId ? props.reply.userId.nameOrNickname : '';
  let isPractitioner = false;
  if(props.reply.userId) {
    nameOrNickname = props.reply.userId.nameOrNickname;
    isPractitioner = !!props.reply.userId.isDietitian || !!props.reply.userId.isVendorBoothHost;
  }
  const reply = (props.reply.comment||"").replace(/@\[(.+?)\]\((.+?)\)/g, (match, name, id) => {
    return `<span class="mention" data-user-id="${id}">${name.trim()}</span>`;
  });

  const replyMoment = moment(props.reply.dateCreated);
  const srReplyLabel = `Reply from ${nameOrNickname}`;
  const ago = new Ago(replyMoment);
  const srReply = `${ago.readable}, ${nameOrNickname} said ${stripHtml( reply )}`;

  return (
      <div className={`comment-reply ${props.relatedNotification?'related-to-notification':''} ${props.hideNotificationIcon?'no-bell':''}`} role={'list-item'} aria-label={srReplyLabel}>
        <span className={'visuallyhidden'}>{srReply}</span>
        <div className={"crep-avatar"} aria-hidden>
          <NavAvatar user={props.reply.userId} variant={'xsmall'} />
        </div>
        <div className={"crep-body"} aria-hidden>
          <h4 className={`crep-name-and-date${isPractitioner?' verified':''}`}>
            {isPractitioner && <span className="material-icons verified" aria-hidden="true">verified</span>}
            <strong>{nameOrNickname}</strong>
            <span className={"ago"}>{ago.visible}</span>
          </h4>
          <p className="crep-text" dangerouslySetInnerHTML={{ __html:reply}} />
          {props.relatedNotification && <>
              {!props.hideNotificationIcon && <div className={"notification-indicator-bell"}>{props.relatedNotification.type==NotificationTypeHelper.notificationTypes.MENTION.type ? <MentionIcon /> : <ReplyIcon />}</div>}
              <div className={`notification-indicator`}></div>
            </>
          }
        </div>
      </div>
  );

}
